import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = ():string => {
    return `/images`
};


function api() {
    return {
        getList: (data:RequestData) => {
            const {params={}} = data;
            return HttpRequest.get(getUrl(), {
                params : params
            });
        },

        create: (data:RequestData) => {
            return HttpRequest.post(getUrl(), data.payload.formData, {
                onUploadProgress : data.payload.onProgressCallback
            });
        },

        getItem: (data:RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest.get(url);
        },

        update : (data:RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest.put(url, data.payload, {});
        },

        addTags:(data:RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}/tags`;
            return HttpRequest.post(url, data.payload, {});
        },

        deleteTags:(data:RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}/tags`;
            return HttpRequest.delete(url, {
                data : data.payload
            });
        },
        delete : (data:RequestData) => {
            const url = `${getUrl()}/${getPropByString(data, "params.id")}`;
            return HttpRequest.delete(url, {});
        }
    };
}

export default api();
